/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-danger */
/* eslint-disable import/no-cycle */
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ChevronIcon } from './ChevronIcon';
import './Accordion.css';
import { DeleteLink, EditLink } from '../Card/ListItemCard';
import { scrollQuestionIntoView } from '../../../utils';

const Text = styled.p`
  display: block;
  font-size: 1.5rem;
  margin-top: 0;
  margin-bottom: 0.5rem;
  margin-left: 0;
  margin-right: 0;
  font-weight: 500;
  color: rgba(93, 93, 93, 1);
  @media only screen and (max-width: 767px) {
    max-width: 150px;
  }
`;

const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  ${({ customAccordion, togglerClassName }) =>
    customAccordion && (togglerClassName === 'expanded' ? 'padding: 20px;' : 'padding: 0;')}
  & > div:first-of-type {
    width: 20%;
    ${({ customAccordion }) => `max-width: ${customAccordion ? '120px' : '40px'}`}
  }
  & > div:last-of-type {
    flex: 1;
  }
  @media only screen and (max-width: 1100px) {
    & > div:first-of-type {
      width: 100%;
      ${({ customAccordion }) => `max-width: ${customAccordion ? '100%' : '40px'}`}
    }
    ${({ customAccordion, togglerClassName }) =>
      customAccordion && (togglerClassName === 'expanded' ? 'padding: 20px;' : 'padding: 0;')}
    ${({ togglerClassName }) => togglerClassName === 'expanded' && 'flex-direction: column'};
  }
`;

const ListButtonWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  @media only screen and (max-width: 1100px) {
    justify-content: flex-end;
    margin-bottom: 20px;
  }
`;

const Accordion = ({
  title,
  index,
  len,
  isReview,
  children,
  customAccordion,
  deleteBtnLabel = 'Delete',
  expanded,
  togglerClassName,
  toggleExpanded,
  onEditClick,
  setDeleteCover,
  isListEditable,
  theme,
  role,
}) => {
  const extendChild = (child) => React.cloneElement(child, { showQuestionText: false });
  const extendedChildren = Array.isArray(children)
    ? children.map(extendChild)
    : extendChild(children);

  useEffect(() => {
    if (index !== len - 1 && !isReview) {
      toggleExpanded(false);
    }
  }, [index, len, isReview]);

  const handleFocus = (e) => {
    scrollQuestionIntoView({
      element: e.target,
      theme,
      role,
      pageId: theme.pageId,
    });
  };

  return (
    <AccordionWrapper
      className={ `Accordion ${togglerClassName}` }
      togglerClassName={ togglerClassName }
      customAccordion={ customAccordion }
    >
      <div name='accordion-header'>
        {customAccordion ? (
          expanded && (
            <ListButtonWrapper>
              <EditLink onClick={ onEditClick } disabled={ !isListEditable } onFocus={ handleFocus }>
                Edit
              </EditLink>
              <DeleteLink
                onClick={ () => setDeleteCover(true, expanded) }
                disabled={ !isListEditable }
                onFocus={ handleFocus }
              >
                {deleteBtnLabel}
              </DeleteLink>
            </ListButtonWrapper>
          )
        ) : (
          <div name='accordion-header' onClick={ toggleExpanded }>
            <ChevronIcon />
            <Text className='padding-bottom-15'>{title}</Text>
          </div>
        )}
      </div>
      <div className={ `AccordionContent ${togglerClassName}` }>{extendedChildren}</div>
    </AccordionWrapper>
  );
};

export default Accordion;
